import React from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/components/servicesTableCellsStyle';
import { makeStyles } from '@material-ui/core';
import { Caption } from 'components/Typography/Typography';
import Done from '@material-ui/icons/Done';
import Close from '@material-ui/icons/Close';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import classNames from 'classnames';

// @ts-ignore
const useStyles = makeStyles(styles);

interface ICheckCellProps {
	checked: boolean;
	subtitle: string;
	title: string;
	backgroundColor?: types.newServices.backgroundColor;
}

const CheckCell = ({ checked, subtitle, title, backgroundColor = 'white' }: ICheckCellProps) => {
	const classes = useStyles();

	return (
		<div
			className={classNames(classes.cell, {
				[classes[`${backgroundColor}Color`]]: true,
			})}
		>
			<div
				className={classNames({
					[classes.checkCellSuccess]: checked,
					[classes.checkCellFailure]: !checked,
				})}
			>
				<ConditionalRender show={checked} onTrue={() => <Done />} onFalse={() => <Close />} />
			</div>
			<Caption color="disabled-light" disableMargin>
				{subtitle}
			</Caption>
			<Caption color="disabled-light" disableMargin>
				{title}
			</Caption>
		</div>
	);
};

export default CheckCell;
